import * as Sentry from "@sentry/react";

type ImportProject = {
  importReportDocumentId?: string | null;
  data?: { importConversationStartersDismissedForReport?: string | null };
  update: (data: { importConversationStartersDismissedForReport: string }) => Promise<unknown>;
};

/** Keep the report and generated suggestions; only retire this import's welcome. */
export async function dismissImportConversationStarters(project: ImportProject | null | undefined): Promise<void> {
  const reportId = project?.importReportDocumentId;
  if (!project || !reportId || project.data?.importConversationStartersDismissedForReport === reportId) return;

  try {
    // Project.update applies this optimistically and persists through the existing save queue.
    // Use the report ID even if its suggestions are still being generated.
    await project.update({ importConversationStartersDismissedForReport: reportId });
  } catch (error) {
    Sentry.captureException(error);
  }
}
